import * as React from "react";
import "./src/styles/global.css";
import { AppProviders } from "./src/components/app-providers";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <AppProviders>{element}</AppProviders>;
};
